import { AppBar, Toolbar, withStyles } from '@material-ui/core';
import React from 'react';
import PropTypes from 'prop-types';

import UserMenuContainer from '../UserMenu/UserMenuContainer';
import ClientPicker from '../ClientPicker';
import logo from './arch.svg';
import styles from './styles';

function MainToolbar({ classes, menu }) {
  const Menu = menu || UserMenuContainer;
  return (
    <AppBar
      position="absolute"
      color="primary"
      classes={{ colorPrimary: classes.appBarColor }}
      className={classes.appBarShift}
    >
      <Toolbar className={classes.toolbar}>
        <a href="/" className={classes.logoWrapper}>
          <img src={logo} className={classes.logo} alt="Mane" />
        </a>

        <ClientPicker />

        <Menu />
      </Toolbar>
    </AppBar>
  );
}

MainToolbar.propTypes = {
  menu: PropTypes.node,
};

MainToolbar.defaultProps = {
  menu: null,
};

export default withStyles(styles, { withTheme: true })(MainToolbar);
